import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

interface OfficeHour {
  avatar: string;
  name: string;
  job_title: string;
  scheduler_url: string;
  topics: string[];
}

const officeHours = [
  {
    avatar: 'abby',
    name: 'Abby',
    job_title: 'Senior Product Manager',
    scheduler_url: 'https://scheduler.zoom.us/abby-grous/office-hours',
    topics: ['Direct'],
  },
  {
    avatar: 'andrew',
    name: 'Andrew',
    job_title: 'Director of Product',
    scheduler_url: 'https://scheduler.zoom.us/andrew-schorr/office-hours',
    topics: ['VRBO', 'Booking.com', 'Inbox'],
  },
  {
    avatar: 'emily',
    name: 'Emily',
    job_title: 'Senior Product Manager',
    scheduler_url: 'https://scheduler.zoom.us/emily-tunggala/office-hours',
    topics: ['Owner statements', 'Airbnb', 'Integrations', 'Reservation financials'],
  },
  {
    avatar: 'nik',
    name: 'Nik',
    job_title: 'Principal Software Engineer',
    scheduler_url: 'https://scheduler.zoom.us/nik-logachev/office-hours',
    topics: ['AI', 'Upsells'],
  },
  {
    avatar: 'sam',
    name: 'Sam',
    job_title: 'Director of Engineering',
    scheduler_url: 'https://scheduler.zoom.us/hospitable-sam/office-hours',
    topics: ['Engineering', 'Hospitable APIs'],
  },
  {
    avatar: 'tim',
    name: 'Tim',
    job_title: 'Senior Product Manager',
    scheduler_url: 'https://scheduler.zoom.us/tim-hasfgr/office-hours',
    topics: ['Smart devices', 'Onboarding', 'Insurance'],
  },
  {
    avatar: 'brandon',
    name: 'Brandon',
    job_title: 'Accountant in Residence',
    scheduler_url: 'https://scheduler.zoom.us/brandon-huetteman/office-hours',
    topics: ['Accounting', 'QuickBooks'],
  },
];

@Component({
  standalone: false,
  templateUrl: './dialog-office-hours.component.html',
  styleUrls: ['./dialog-office-hours.component.scss'],
})
export class DialogOfficeHoursComponent {
  officeHours: OfficeHour[] = officeHours;

  constructor(public dialogRef: MatDialogRef<DialogOfficeHoursComponent>) {}
}
